import React, {
  createContext,
  useMemo,
  useState,
  useContext,
  useEffect,
} from "react";
import CustomTabPanel from "../../../../components/TabPanels/CustomTabPanel";
import { Box, Tab, Tabs } from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import AgricultureIcon from "@mui/icons-material/Agriculture";
import ArticleIcon from "@mui/icons-material/Article";
import DashPedidoMaquinariaDatosGenerales from "./DashPedidoMaquinariaDatosGenerales";
import DashPedidoMaquinariaUnidadesVendidas from "./DashPedidoMaquinariaUnidadesVendidas";
import DashPedidoMaquinariaDetalleFinanciamiento from "./DashPedidoMaquinariaDetalleFinanciamiento";
import { DashPedidoCondicionesCredito } from "./DashPedidoCondicionesCredito";
import { MyContext } from "../../DashClienteMainScreen";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useHistory, useLocation } from "react-router-dom";
import request from "../../../../../Helpers/API";
import Swal from "sweetalert2";

// Creación del contexto para compartir datos entre componentes
export const Context = createContext(null);

export const DashPedidoMaquinariascreen = () => {
  const history = useHistory();
  const location = useLocation();
  // Este componente se abre desde DashGenerarSolicitudCredito (dentro de CRMMainScreen, sin
  // MyContext) o, en el flujo legado, dentro de DashClienteMainScreen (con MyContext). El folio,
  // idcliente y tipo de solicitud ahora llegan por location.state; el contexto queda de respaldo.
  const context = useContext(MyContext);
  const folioSolicitud = location.state?.folio ?? context?.state?.folio;
  const idclienteSolicitud = location.state?.idcliente ?? context?.state?.idcliente;
  const [tipoSolicitud, setTipoSolicitud] = useState("")
  // Estado para manejar el valor de la pestaña seleccionada
  const [value, setValue] = useState(0);
  const [screen, setScreen] = useState(0);
  const [statePedido, setStatePedido] = useState({
    solicitante: "",
    rfc: "",
    unidadesvendidas: false,
    condicionescredito: false,
    detallesfinanciamiento: false,
  });
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // Valor del contexto para compartir el estado y la función de actualización.
  // Se agregan folio/idcliente/tipo_solicitud para que las pestañas hijas (Datos Generales,
  // Unidades Vendidas, Condiciones de la Operación) ya no dependan de MyContext.
  const contextValue = useMemo(
    () => ({
      state: {
        ...statePedido,
        folio: folioSolicitud,
        idcliente: idclienteSolicitud,
        tipo_solicitud: tipoSolicitud,
      },
      setState: setStatePedido,
    }),
    [statePedido, setStatePedido, folioSolicitud, idclienteSolicitud, tipoSolicitud]
  );

  useEffect(() => {
    // setLoading(true);
    request
      .get(`SolicitudCredito/ObtenerID?folio=${folioSolicitud}`)
      .then((result) => {
        // setLoading(false);
        setTipoSolicitud(result.tipo_solicitud)
      })
      .catch((error) => {
        // setLoading(false);
        Swal.fire("SOLICITUD DE CREDITO", JSON.stringify(error), "error");
      });
  }, []);
  // console.log(tipoSolicitud)

  const [bottonguardar, setBottonguardar] = useState(() => <div></div>);
  useEffect(() => {
    if (
      folioSolicitud === undefined ||
      folioSolicitud === null ||
      folioSolicitud.length !== 13
    ) {
      history.push("/DashClientes/solicitudcreditoGenerar", {
        idcliente: idclienteSolicitud,
      });
    } else {
      if (location.state.vista !== undefined && location.state.vista !== null) {
        setScreen(Number(location.state.vista) + 1);
        if (Number(location.state.vista) >= 3) {
          setValue(0);
        } else {
          setValue(Number(location.state.vista) + 1);
        }
      }
    }
  }, []);
  useEffect(() => {
    var unidadesvendidas = Number(screen) >= 1 ? false : true;
    var condicionescredito = Number(screen) >= 2 ? false : true;
    var detallesfinanciamiento = Number(screen) >= 3 ? false : true;
    setStatePedido({
      ...statePedido,
      unidadesvendidas,
      condicionescredito,
      detallesfinanciamiento,
    });
  }, [screen]);
  return (
    <Context.Provider value={contextValue}>
      <div className="crm-main-screen">
        <div className="crm-body">
          <div className="crm-page">
            <div className="crm-module">
              <div className="crm-module-head">
                <div className="crm-head-grid">
                  <div className="crm-head-left">
                    <button
                      className="crm-btn-regresar"
                      onClick={() =>
                        history.push("/DashClientes/solicitudcreditoGenerar", {
                          folio: folioSolicitud,
                          idcliente: idclienteSolicitud,
                          tipo_solicitud: tipoSolicitud,
                        })
                      }
                    >
                      <ArrowBackIcon /> Regresar
                    </button>
                  </div>
                  <div className="crm-head-center">
                    <h1 className="crm-module-title">LLENADO DE SOLICITUD</h1>
                  </div>
                  <div className="crm-head-right" />
                </div>
                <div className="crm-head-divider">
                  <div className="crm-head-divider-dot" />
                </div>
              </div>
        {tipoSolicitud === "C" ? (
          <Box className="pedido-maquinaria-container">
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs value={value} onChange={handleChange} variant="fullWidth">
                <Tab icon={<AccountCircleIcon />} label="Datos del Solicitante" />
                <Tab
                  disabled={statePedido.unidadesvendidas}
                  icon={<AgricultureIcon />}
                  label="Unidades Solicitadas"
                />
                <Tab
                  disabled={statePedido.condicionescredito}
                  icon={<ArticleIcon />}
                  label="Condiciones de la Operación"
                />
              </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
              <DashPedidoMaquinariaDatosGenerales
                setValue={setValue}
                setScreen={setScreen}
                screen={screen}
                setBottonguardar={setBottonguardar}
              />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <DashPedidoMaquinariaUnidadesVendidas
                value={value}
                setValue={setValue}
                screen={screen}
                setScreen={setScreen}
                setBottonguardar={setBottonguardar}
              />
            </CustomTabPanel>
            <CustomTabPanel index={2} value={value}>
              <DashPedidoCondicionesCredito
                tipoSolicitud={tipoSolicitud}
                setValue={setValue}
                setScreen={setScreen}
                screen={screen}
                setBottonguardar={setBottonguardar}
                idclienteSolicitud={idclienteSolicitud}
              />
            </CustomTabPanel>
          </Box >
        ) : (
          <Box className="pedido-maquinaria-container">
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs value={value} onChange={handleChange} variant="fullWidth">
                <Tab icon={<AccountCircleIcon />} label="Datos del Solicitante" />
                <Tab
                  disabled={statePedido.unidadesvendidas}
                  icon={<AgricultureIcon />}
                  label="UNIDADES SOLICITADAS"
                />
                <Tab
                  disabled={statePedido.condicionescredito}
                  icon={<ArticleIcon />}
                  label="CONDICIONES DE LA OPERACION"
                />
                <Tab
                  disabled={statePedido.detallesfinanciamiento}
                  icon={<ArticleIcon />}
                  label="DETALLES DEL FINANCIAMIENTO"
                />
              </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
              <DashPedidoMaquinariaDatosGenerales
                setValue={setValue}
                setScreen={setScreen}
                screen={screen}
                setBottonguardar={setBottonguardar}
              />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <DashPedidoMaquinariaUnidadesVendidas
                value={value}
                setValue={setValue}
                screen={screen}
                setScreen={setScreen}
                setBottonguardar={setBottonguardar}
              />
            </CustomTabPanel>
            <CustomTabPanel index={2} value={value}>
              <DashPedidoCondicionesCredito
                setValue={setValue}
                setScreen={setScreen}
                screen={screen}
                setBottonguardar={setBottonguardar}
                idclienteSolicitud={idclienteSolicitud}
              />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={3}>
              <DashPedidoMaquinariaDetalleFinanciamiento
                setBottonguardar={setBottonguardar}
                idclienteSolicitud={idclienteSolicitud}
              />
            </CustomTabPanel>
          </Box >
        )
        }
        <div className="pedido-maquinaria-container-footer">
          {bottonguardar}
        </div>
            </div>
          </div>
        </div>
      </div>
    </Context.Provider >
  );
};
